<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button> -->
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- <el-button v-if="tableAcl.indexOf('FinishOrder') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="showFinishOrdersDialog">关闭订单</el-button> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="190" prop="no" label="订单号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="150" prop="supplierName" label="供应商"></el-table-column>
        <el-table-column width="100" prop="createdUserName" label="发起人"></el-table-column>
        <!-- <el-table-column width="120" prop="stateName" label="订单状态"></el-table-column> -->
        <el-table-column prop="createdTime" label="创建时间" min-width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column width="110" prop="deliveryTime" label="要求送达日期">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.deliveryTime), "{y}-{m}-{d}")
          }}</template>
        </el-table-column>
        <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
        <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
        <!-- <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames"></el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column> -->
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oneLevelWarehouseInfo" label="收货信息" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column width="160" prop="updateTime" label="最后更新时间">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.updateTime), "{y}-{m}-{d} {h}:{i}:{s}")
          }}</template>
        </el-table-column>
        <el-table-column fixed="right" width="80" prop="printingTimes" label="打印次数"></el-table-column>
        <!-- <el-table-column fixed="right" width="160" label="完成情况">
          <template slot-scope="scope">
            <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row.totalInStockNumber, scope.row.totalOrderNumber)" color="#42b983" />
          </template>
        </el-table-column> -->
        <!-- <el-table-column fixed="right" prop="operation" label="操作" width="100">
          <template slot-scope="scope"> -->
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <!-- <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button> -->
            <!-- <el-button v-if="
                scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button> -->
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <!-- <el-button type="text" v-preventReClick v-if="scope.row.status == 2 && scope.row.sendState==0" @click="sendToMaster(scope.row)" class="margin-left20 color-blue">推送</el-button> -->
            <!-- <el-button type="text" v-preventReClick v-if="tableAcl.indexOf('FinishOrder') != -1 && scope.row.status == 2 && scope.row.sendState==1 && [7, 8, 9].indexOf(scope.row.state) == -1" @click="finishOrder(scope.row)" class="margin-left20 color-blue">关闭订单</el-button> -->
          <!-- </template>
        </el-table-column> -->
      </el-table>

      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <!-- <el-dialog :title="finishOrderDialogTitle" :visible.sync="showFinishOrderDialog" width="640px">
      <el-form ref="finishForm" :model="finishForm" label-width="80px" :rules="finishRules">
        <el-row>
          <el-form-item label="原因" prop="remark">
            <el-input v-model="finishForm.remark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn primary" type="primary" v-preventReClick @click="finishSubmit">确 定</el-button>
        <el-button class="btn default" v-preventReClick @click="showFinishOrderDialog = false">取 消</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  GetPurchaseOrderSmalls,
  // ExportPurchaseOrder,
  GetPurchaseOrderSmallPrintData,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import { PurchaseCategoryOptions, OrderStateOptions, WhetherOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetPurchaseOrderSmalls,
      PrintAction: GetPurchaseOrderSmallPrintData,
      editPath: 'order-small-edit',
      // exportAction: ExportPurchaseOrder,

      PurchaseCategoryOptions: PurchaseCategoryOptions,
      OrderStateOptions: OrderStateOptions,
      WhetherOptions: WhetherOptions,
      filterOptions: [
        {
          name: "订单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo"
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName"
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName"
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "采购计划单号",
          type: "input",
          code: "purchasePlanNo",
        },
        {
          name: "订单状态",
          type: "select",
          code: "states",
          data: OrderStateOptions,
          multiple: true
        },
        {
          name: "采购类型",
          type: "select",
          code: "categorys",
          data: PurchaseCategoryOptions,
          multiple: true
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "是否自动生成",
          type: "select",
          code: "isAutoCreated",
          data: WhetherOptions,
          defaultValue: 0
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "最后更新时间",
          type: "date",
          code: "updateTime",
          startDateCode: "updateTimeStart",
          endDateCode: "updateTimeEnd",
        },
      ],
    };
  },
  methods: {
  },
  created () {
  },
  mounted () {
  },
};
</script>

<style lang="scss" scoped></style>
